/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API Exporter
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Platform Service Type
 * @export
 * @enum {string}
 */

export const ProductServiceType = {
    Poizon: 'POIZON',
    Dewu: 'DEWU',
    Goat: 'GOAT',
    Shihuo: 'SHIHUO'
} as const;

export type ProductServiceType = typeof ProductServiceType[keyof typeof ProductServiceType];



